export function routes($stateProvider) {
  $stateProvider
    .state('app.produto', {
      url: '/produto',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.produto.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Produtos',
      template: require('./directory/directory.view.html'),
      controller: 'ProdutoListController',
      controllerAs: 'vm',
      role: 'produtoRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "asc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.produto.details', {
      url: '/{id}',
      title: 'Produto',
      controller: 'ProdutoDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'produtoRead'
    })
    .state('app.produto.new', {
      url: '/nova',
      title: 'Adicionar Produto',
      template: require('./new/new.view.html'),
      controller: 'ProdutoCreateProdutoController',
      controllerAs: 'vm',
      role: 'produtoCreate'
    })
    .state('app.produto.new.1', {
      template: require('./new/produto.1.form.html')
    })
    .state('app.produto.new.2', {
      template: require('./new/produto.2.form.html')
    })
    .state('app.produto.new.3', {
      template: require('./new/produto.3.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
